<app-dialog [visible]="true" [closable]="false" cssClass="dialog-med">
  <app-loading *ngIf="saving$ | async" message="Loading"></app-loading>
    <div class="header">
        <div class="row space-between">
          <h3>Support Request: {{userName}}</h3>

        </div>
    </div>
      <div class="body">
        <div class="field-subtitle">
            <p>Most questions can be answered with these articles in our Resource Center. 
              <a
                target="new"
                href="https://auth.allegion.com/samlp/15ifRUv6OVSrkyRQDVOhoisETC5eEOp6?RelayState=https://support.restrictedproduct.allegion.com/"
                >Click here </a
              >
               
            </p>
          </div>
        <div class="field-subtitle">
          <h4 class="flex-auto padding all">All fields are required(*) unless indicated optional</h4>
          <form [formGroup]="ticketForm" class="flex flex-col mt-3">
            <div class="row padding all">
                <div class="flex-auto med-input padding all">
                    <h4 class="flex-auto padding all">My Email</h4>
                    <p class="flex-auto padding all">{{userEmail}}</p>
                </div>
                <!-- <mat-form-field appearance="outline" class="fill med-input flex-auto padding all">
                    <mat-label>Phone Number</mat-label>
                    <input matInput class="input-font" formControlName="phoneNumber" type="text" />
                </mat-form-field> -->
            </div>
            <div class="row padding all">
                <mat-form-field appearance="outline" floatLabel="always" class="fill med-input flex-auto padding all">
                    <mat-label>Account Number</mat-label>
                    <input matInput class="input-font" formControlName="accountNumber" type="text" />
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="fill med-input flex-auto padding all">
                    <mat-label>Account Name</mat-label>
                    <input matInput class="input-font" formControlName="accountName" type="text" />
                </mat-form-field>
            </div>
            <div class="row padding all">
                <mat-form-field appearance="outline" floatLabel="always" class="fill sml-input flex-auto padding all">
                    <mat-label>Priority</mat-label>
                    <mat-select formControlName="priority">
                        <mat-option [value]="'Low'">
                            Low
                        </mat-option>
                        <mat-option [value]="'Normal'">
                            Normal
                        </mat-option>
                        <mat-option [value]="'High'">
                            High
                        </mat-option>
                        <mat-option [value]="'Urgent'" [disabled]>
                            Urgent
                        </mat-option>
                      </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" floatLabel="always" class="fill lrg-input flex-auto padding all">
                    <mat-label>My question is related to:</mat-label>
                    <mat-select formControlName="subject">
                        <mat-option [value]="'User Account/Access'">
                            User Account/Access
                        </mat-option>
                        <mat-option [value]="'RP Account'">
                            RP Account
                        </mat-option>
                        <mat-option [value]="'Manage Users'">
                            Manage Users
                        </mat-option>
                        <mat-option [value]="'Add Contacts/Addresses'">
                            Add Contacts/Addresses
                        </mat-option>
                        <mat-option [value]="'Create Authorization'">
                            Create Authorization
                        </mat-option>
                        <mat-option [value]="'Report a Bug'">
                            Report a Bug
                        </mat-option>
                      </mat-select>
                </mat-form-field>
            </div>
            <div class="row padding left right">
                <h4 class="flex-auto padding all">Please provide a brief description of your Restricted Product issue: *</h4>
            </div>
            <div class="row padding all">
                <mat-form-field floatLabel="always" appearance="outline" class="fill lrg-input flex-auto padding all">
                    <textarea
                    maxlength="500"
                    [(ngModel)]="descriptionContent"
                    #newDescription
                    formControlName="description"
                    matInput
                    rows="6"
                    placeholder="Type description here"
                    cdkTextareaAutosize
                    #autosize="cdkTextareaAutosize"
                    cdkAutosizeMinRows="1"
                    cdkAutosizeMaxRows="6"
                    >
                    </textarea>
                    <div class="row flex-end">
                        <mat-hint>{{ descriptionContent?.length || 0 }} / 500</mat-hint>
                    </div>
                </mat-form-field>
            </div>
            <div class="row padding left right">
                <h4 class="flex-auto padding all">Screenshot Upload: this greatly helps us in troubleshooting.</h4>
            </div>
            <div *ngIf="filesToUpload.length === 0" class="row padding all">
                <div class="dropzone padding left right">
                    <input type="file" #fileDropRef id="fileDropRef" multiple accept="img, png, jpg " (change)="uploadAttachment($event.target.files)">
                    <mat-icon>cloud_upload</mat-icon>
                    <h3>Click or Drag File Here</h3>
                </div>

            </div>
            <div class="row padding all flex" *ngIf="filesToUpload.length > 0">
                
                    <div class="fileToUpload padding all" *ngFor="let file of filesToUpload">
                        <h4 class="padding all">{{file.name}}</h4>
                        <p class="padding all">{{file.type}}</p>
                        <button matButton class="margin left lrg" (click)="removeFile()"><mat-icon>delete</mat-icon></button>
                    </div>
                
            </div>
          </form>
        </div>
      </div>
    <div class="footer">
        <button mat-stroked-button i18n class="margin right" (click)="close()">Cancel</button>
        <button mat-flat-button color="primary" (click)="submit()" [disabled]="ticketForm.invalid || processingTicketSubmission">Submit</button>
      </div>
</app-dialog>
